<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMessageContext } from '../provider.js';
import Icon from 'next/icon/Icon.vue';
import BaseBubble from 'next/message/bubbles/Base.vue';
import MessageFormatter from 'shared/helpers/MessageFormatter.js';

const emit = defineEmits(['error']);
const { t } = useI18n();
const { content, contentAttributes, attachments } = useMessageContext();

const attachment = computed(() => attachments.value[0]);
const permalink = computed(() => contentAttributes.value?.mediaPermalink);
const hasImageError = ref(false);

const formattedContent = computed(
  () => new MessageFormatter(content.value).formattedMessage
);

const onImageError = () => {
  hasImageError.value = true;
  emit('error');
};
</script>

<template>
  <BaseBubble class="p-3 overflow-hidden" data-bubble-name="ig-comment-post">
    <p class="mb-1 text-xs text-n-slate-11">
      {{ t('COMPONENTS.FILE_BUBBLE.INSTAGRAM_COMMENT_ON_POST') }}
    </p>
    <img
      v-if="attachment && !hasImageError"
      class="rounded-lg max-w-80 mb-2 skip-context-menu"
      :src="attachment.dataUrl"
      @error="onImageError"
    />
    <div
      v-else-if="hasImageError"
      class="flex items-center gap-1 px-5 py-4 mb-2 text-center rounded-lg bg-n-alpha-1"
    >
      <Icon icon="i-lucide-image-off" class="text-n-slate-11" />
    </div>
    <div v-if="content" v-dompurify-html="formattedContent" class="mb-2" />
    <a
      v-if="permalink"
      :href="permalink"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center gap-1 text-xs text-woot-500 hover:underline"
    >
      {{ t('COMPONENTS.FILE_BUBBLE.INSTAGRAM_COMMENT_VIEW_POST') }}
      <Icon icon="i-lucide-external-link" class="size-3" />
    </a>
  </BaseBubble>
</template>
